export default {
  patientAuth: {
    alert: {
      chat: {
        title: 'Note',
        description:
          'Your provider has requested you to answer these questions with our Virtual Care Assistant, Lumi. This will give you the opportunity to share details of your medical history that are not available in your medical record.',
      },
      form: {
        title: 'Note',
        description:
          'Your provider has requested you to complete this form. Please verify your identity to continue.',
      },
    },
    dob: {
      label: 'Enter your date of birth to continue',
      placeholder: 'MM/DD/YYYY',
      requiredError: 'Please enter your date of birth',
      formatError: 'Please enter a valid date in MM/DD/YYYY format',
      validationError: 'Date of Birth does not match our records.',
    },
    submit: 'Submit',
    troubleLoggingIn: 'Having trouble logging in?',
    emergencyGuideline:
      'If you are having a medical emergency, please discontinue this intake and call 911',
    languageToggle: 'En Español?',
  },
  errors: {
    logoutFailed: 'Logout failed. Please try again',
    userValidationFailed: 'Failed to validate user. Please try again',
    expiredLink: {
      title: 'Oops!',
      description:
        'The appointment link seems to be invalid or expired. Please check the link in your email or contact your care team for assistance.',
    },
  },
  logout: {
    title: 'Logout',
    description:
      'You have successfully logged out. You may now close this window.',
  },
};
